import React from "react";
import { Route, Redirect } from "react-router-dom";
import {route} from '../Utils/constants.js';
import {onlyRoutesAccess} from '../Utils/onlyProductAccess'

export const ProtectedRoute = ({
  component: Component,granted,isAdmin,channel,path,clean,
  ...rest
}) => granted && onlyRoutesAccess(path,channel)? (
  <Route
      {...rest}
      render={props => {
          if (clean) clean()
          return( <Component {...props} />);
      }}
    />
) : (
  <Redirect
    to={{
      pathname: route.PATH
      // state: { from: location }
    }}
  />
) 




  
